import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Header from "../components/Header";
import "./PageTemplate.css";
import styles from "./Project.module.css";
import projectEEG from "../assets/images/project-eeg.jpg";
import projectHOSA from "../assets/images/project-hosa.jpg";
import emotikids1 from "../assets/images/emotikids1.png";
import emotikids2 from "../assets/images/emotikids2.png";
import emotikids3 from "../assets/images/emotikids3.png";
import emotikids4 from "../assets/images/emotikids4.png";
import emotikids5 from "../assets/images/emotikids5.png";
import projectGallery1 from "../assets/images/project-gallery-1.jpg";
import projectGallery2 from "../assets/images/project-gallery-2.jpg";
import projectGallery3 from "../assets/images/project-gallery-3.jpg";
import projectGallery4 from "../assets/images/project-gallery-4.jpg";
import projectGallery5 from "../assets/images/project-gallery-5.jpg";
import projectGallery6 from "../assets/images/project-gallery-6.jpg";
import projectGallery7 from "../assets/images/project-gallery-7.png";
import projectGallery8 from "../assets/images/project-gallery-8.jpg";
import projectGallery9 from "../assets/images/project-gallery-9.jpg";
import projectGallery10 from "../assets/images/project-gallery-10.jpg";
import projectGallery11 from "../assets/images/project-gallery-11.jpg";
import projectGallery12 from "../assets/images/project-gallery-12.jpg";
import projectGallery13 from "../assets/images/project-gallery-13.jpg";
import projectGallery14 from "../assets/images/project-gallery-14.jpg";
import projectGallery15 from "../assets/images/project-gallery-15.jpg";
import projectGallery16 from "../assets/images/project-gallery-16.jpg";
import projectGallery17 from "../assets/images/project-gallery-17.jpg";
import projectGallery18 from "../assets/images/project-gallery-18.jpg";
import projectGallery19 from "../assets/images/project-gallery-19.jpg";
import projectGallery20 from "../assets/images/project-gallery-20.jpg";
import projectGallery21 from "../assets/images/project-gallery-21.jpg";
import projectGallery22 from "../assets/images/project-gallery-22.jpg";
import projectGallery23 from "../assets/images/project-gallery-23.jpg";
import projectGallery24 from "../assets/images/project-gallery-24.jpg";
import projectGallery26 from "../assets/images/project-gallery-26.jpg";
import projectGallery29 from "../assets/images/project-gallery-29.jpg";
import projectGallery30 from "../assets/images/project-gallery-30.jpg";

const Project: React.FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const renderTitleWithLinks = (title: string) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const parts = title.split('\n');

    return parts.map((part, index) => {
      const matches = part.match(urlRegex);
      if (matches) {
        return (
          <span key={index}>
            {part.split(urlRegex).map((text, i) => {
              if (matches.includes(text)) {
                return (
                  <a
                    key={i}
                    href={text}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: '#7995E3', textDecoration: 'underline' }}
                  >
                    {text}
                  </a>
                );
              }
              return text;
            })}
            {index < parts.length - 1 && <br />}
          </span>
        );
      }
      return (
        <span key={index}>
          {part}
          {index < parts.length - 1 && <br />}
        </span>
      );
    });
  };

  const renderDescription = (description: string) => {
    const parts = description.split('\n');

    const renderTextWithBoldAndLinks = (text: string, keyPrefix: string) => {
      const elements: React.ReactNode[] = [];
      let lastIndex = 0;
      const combinedRegex = /(\*\*[^*]+\*\*)|(https?:\/\/[^\s]+)/g;
      let match;

      while ((match = combinedRegex.exec(text)) !== null) {
        if (match.index > lastIndex) {
          elements.push(text.slice(lastIndex, match.index));
        }
        if (match[1]) {
          const boldText = match[1].slice(2, -2);
          elements.push(<strong key={`${keyPrefix}-bold-${match.index}`}>{boldText}</strong>);
        } else if (match[2]) {
          elements.push(
            <a
              key={`${keyPrefix}-link-${match.index}`}
              href={match[2]}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#7995E3', textDecoration: 'underline' }}
            >
              {match[2]}
            </a>
          );
        }
        lastIndex = match.index + match[0].length;
      }
      if (lastIndex < text.length) {
        elements.push(text.slice(lastIndex));
      }
      return elements;
    };

    return parts.map((part, index) => (
      <span key={index}>
        {renderTextWithBoldAndLinks(part, `line-${index}`)}
        {index < parts.length - 1 && <br />}
      </span>
    ));
  };

  const galleryImages = [
    projectGallery1, projectGallery2, projectGallery3, projectGallery4, projectGallery5, projectGallery6,
    projectGallery7, projectGallery8, projectGallery9, projectGallery10, projectGallery11, projectGallery12,
    projectGallery13, projectGallery14, projectGallery15, projectGallery16, projectGallery17, projectGallery18,
    projectGallery19, projectGallery20, projectGallery21, projectGallery22, projectGallery23, projectGallery24,
    projectGallery26, projectGallery29, projectGallery30,
  ];

  const imagesPerRow = 6;
  const galleryRows = [];
  for (let i = 0; i < galleryImages.length; i += imagesPerRow) {
    galleryRows.push(galleryImages.slice(i, i + imagesPerRow));
  }

  const rowsPerPage = 3;
  const totalPages = Math.ceil(galleryRows.length / rowsPerPage);

  const [galleryPage, setGalleryPage] = useState(0);
  const [galleryTouchStart, setGalleryTouchStart] = useState(0);
  const [galleryTouchEnd, setGalleryTouchEnd] = useState(0);
  const [isGalleryDragging, setIsGalleryDragging] = useState(false);

  const emotikidsImages = [emotikids1, emotikids2, emotikids3, emotikids4, emotikids5];
  const [emotikidsIndex, setEmotikidsIndex] = useState(0);

  const handleEmotikidsPrev = () => {
    setEmotikidsIndex((prev) => (prev === 0 ? emotikidsImages.length - 1 : prev - 1));
  };

  const handleEmotikidsNext = () => {
    setEmotikidsIndex((prev) => (prev === emotikidsImages.length - 1 ? 0 : prev + 1));
  };

  const handleGalleryTouchStart = (e: React.TouchEvent | React.MouseEvent) => {
    setIsGalleryDragging(true);
    const clientX = "touches" in e ? e.touches[0].clientX : e.clientX;
    setGalleryTouchStart(clientX);
  };

  const handleGalleryTouchMove = (e: React.TouchEvent | React.MouseEvent) => {
    if (!isGalleryDragging) return;
    const clientX = "touches" in e ? e.touches[0].clientX : e.clientX;
    setGalleryTouchEnd(clientX);
  };

  const handleGalleryTouchEnd = () => {
    if (!isGalleryDragging) return;
    setIsGalleryDragging(false);

    const swipeThreshold = 50;
    const diff = galleryTouchStart - galleryTouchEnd;

    if (diff > swipeThreshold && galleryPage < totalPages - 1) {
      setGalleryPage(galleryPage + 1);
    } else if (diff < -swipeThreshold && galleryPage > 0) {
      setGalleryPage(galleryPage - 1);
    }

    setGalleryTouchStart(0);
    setGalleryTouchEnd(0);
  };

  const visibleRows = galleryRows.slice(
    galleryPage * rowsPerPage,
    (galleryPage + 1) * rowsPerPage
  );

  const projects = [
    {
      id: 6,
      image: "/images/Research 3 pic.jpg",
      title: t("project.cards.card6.title"),
      description: t("project.cards.card6.description"),
      imagePosition: "left",
    },
    {
      id: 7,
      image: "/images/Research 4 pic.jpg",
      title: t("project.cards.card7.title"),
      description: t("project.cards.card7.description"),
      imagePosition: "right",
    },
    {
      id: 1,
      image: projectEEG,
      title: t("project.cards.card1.title"),
      description: t("project.cards.card1.description"),
      imagePosition: "left",
      isVertical: true,
      hasFrame: true,
    },
    {
      id: 2,
      image: projectHOSA,
      title: t("project.cards.card2.title"),
      description: t("project.cards.card2.description"),
      imagePosition: "right",
      isVertical: true,
      hasFrame: true,
    },
    {
      id: 3,
      image: "",
      title: t("project.cards.card3.title"),
      description: t("project.cards.card3.description"),
      imagePosition: "left",
      isEmotikids: true,
    },
    {
      id: 4,
      image: "/images/Lab 2 pic.jpg",
      title: t("project.cards.card4.title"),
      description: t("project.cards.card4.description"),
      imagePosition: "right",
    },
    {
      id: 5,
      image: "/images/Lab 1 pic.jpg",
      title: t("project.cards.card5.title"),
      description: t("project.cards.card5.description"),
      imagePosition: "left",
    },
  ];

  return (
    <div className={styles.projectPage}>
      <Header />
      <main className={styles.projectContent}>
        <div className={styles.projectContainer}>
          <div className={styles.projectHeader}>
            <h1 className={styles.pageTitle}>{t("project.pageTitle")}</h1>
            <p className={styles.pageSubtitle}>
              Here are some of the projects I've worked on:
            </p>
          </div>
          {projects.map((project) => (
            <div
              key={project.id}
              className={`${styles.projectCard} ${project.isVertical ? styles.vertical : styles[project.imagePosition]} ${project.hasFrame ? styles.framed : ''}`}
            >
              <div className={styles.projectImage}>
                {project.isEmotikids ? (
                  <div className={styles.emotikidsCarousel}>
                    <button
                      className={`${styles.emotikidsNavButton} ${styles.emotikidsNavButtonLeft}`}
                      onClick={handleEmotikidsPrev}
                      aria-label="Previous image"
                    >
                      &#8249;
                    </button>
                    <img src={emotikidsImages[emotikidsIndex]} alt={project.title} />
                    <button
                      className={`${styles.emotikidsNavButton} ${styles.emotikidsNavButtonRight}`}
                      onClick={handleEmotikidsNext}
                      aria-label="Next image"
                    >
                      &#8250;
                    </button>
                  </div>
                ) : (
                  <img src={project.image} alt={project.title} />
                )}
              </div>
              <div className={styles.projectText}>
                <h2 className={styles.projectTitle}>{renderTitleWithLinks(project.title)}</h2>
                <p className={styles.projectDescription}>
                  {renderDescription(project.description)}
                </p>
              </div>
            </div>
          ))}

          <section className={styles.gallerySection}>
            <h2 className={styles.galleryTitle}>
              {t("project.galleryTitle")}
            </h2>
            <div className={styles.galleryContainer}>
              <button
                className={styles.galleryNavButton + ' ' + styles.galleryNavButtonLeft}
                onClick={() => galleryPage > 0 && setGalleryPage(galleryPage - 1)}
                aria-label="Previous gallery page"
              >
                &#8249;
              </button>
              <div
                className={styles.gallery}
                onTouchStart={handleGalleryTouchStart}
                onTouchMove={handleGalleryTouchMove}
                onTouchEnd={handleGalleryTouchEnd}
                onMouseDown={handleGalleryTouchStart}
                onMouseMove={handleGalleryTouchMove}
                onMouseUp={handleGalleryTouchEnd}
                onMouseLeave={() => {
                  if (isGalleryDragging) handleGalleryTouchEnd();
                }}
              >
                {visibleRows.map((row, rowIndex) => (
                  <div key={rowIndex} className={styles.galleryRow}>
                    {row.map((image, imageIndex) => {
                      const overallImageIndex = (galleryPage * rowsPerPage + rowIndex) * imagesPerRow + imageIndex;
                      const isSeventhImage = overallImageIndex === 6;
                      const isEleventhImage = overallImageIndex === 10;
                      return (
                        <img
                          key={imageIndex}
                          src={image}
                          alt={`Project Gallery ${overallImageIndex + 1}`}
                          className={`${styles.galleryImage} ${isSeventhImage ? styles.galleryImageLeft : ''} ${isEleventhImage ? styles.galleryImageRotated : ''}`}
                        />
                      );
                    })}
                  </div>
                ))}
              </div>
              <button
                className={styles.galleryNavButton + ' ' + styles.galleryNavButtonRight}
                onClick={() => galleryPage < totalPages - 1 && setGalleryPage(galleryPage + 1)}
                aria-label="Next gallery page"
              >
                &#8250;
              </button>
            </div>
            <div className={styles.galleryDots}>
              {Array.from({ length: totalPages }).map((_, index) => (
                <div
                  key={index}
                  className={`${styles.galleryDot} ${index === galleryPage ? styles.active : ''}`}
                  onClick={() => setGalleryPage(index)}
                />
              ))}
            </div>
          </section>
        </div>
      </main>
    </div>
  );
};

export default Project;

